import { render, staticRenderFns } from "./PromoCatalog.vue?vue&type=template&id=30f09516&lang=pug&"
import script from "./PromoCatalog.vue?vue&type=script&lang=js&"
export * from "./PromoCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports